import { Icons } from '@commenda/kakashi';
import { useEffect, useRef, useState } from 'react';

interface IndirectTaxCopyFieldProps {
  value: string;
}

const COPY_FEEDBACK_TIMEOUT_MS = 3000;

const IndirectTaxCopyField = ({ value }: IndirectTaxCopyFieldProps) => {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    },
    []
  );

  const handleCopy = () => {
    void navigator.clipboard.writeText(value);
    setCopied(true);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(
      () => setCopied(false),
      COPY_FEEDBACK_TIMEOUT_MS
    );
  };

  return (
    <div className="rounded-md flex items-center bg-bg-secondary justify-between border border-primary h-10 overflow-hidden">
      <div className="txt-small-medium text-text-primary px-xl overflow-hidden">
        <p className="truncate">{value}</p>
      </div>
      <button
        type="button"
        onClick={handleCopy}
        className="flex-shrink-0 flex items-center justify-center gap-sm cursor-pointer bg-bg-primary border-l border-primary w-[100px] h-full appearance-none focus:outline-none"
      >
        <Icons.Copy03 className="size-4 text-button-secondary-fg" />
        <p className="txt-small-bold text-button-secondary-fg">
          {copied ? 'Copied' : 'Copy'}
        </p>
      </button>
    </div>
  );
};

export { IndirectTaxCopyField };
